import _ from 'lodash'
export default function articles(state = [], action) {
  const newState = _.cloneDeep(state)

  switch (action.type) {
    case 'RESET_ARTICLES':
      return Object.assign({}, {}, {})
    case 'GET_ARTICLE_LOADING':
      return Object.assign({}, newState, { loading_article: true, show_result: false, article: {} })
    case 'GET_ARTICLE_FETCHED':
      return Object.assign({}, newState, { loading_article: false, article: action.data, show_result: true })
    case 'GET_ARTICLE_FAILED':
      return Object.assign({}, newState, { message: 'Errore nella ricerca', errorCode: 'error_search', loading_article: false, show_result: false, error: action.data.error })
    case 'PUSH_FOLDER_FETCHED':
      return Object.assign({}, newState, {success: action.data.success})
    case 'PUSH_FOLDER_FAILED':
      return Object.assign({}, newState, { message: 'Errore nella creazione della cartella', errorCode: 'error_folder_creation', error: action.data.error })
    case 'PUSH_ELEMENT_FETCHED':
      return Object.assign({}, newState, {})
    case 'PUSH_ELEMENT_FAILED':
      return Object.assign({}, newState, { message: 'Errore durante il salvataggio', errorCode: 'error_save', error: action.data.error })
    case 'PUSH_FEEDBACK_FETCHED':
      return Object.assign({}, newState, {})
    case 'PUSH_FEEDBACK_FAILED':
      return Object.assign({}, newState, { message: 'Errore nel salvataggio del feedback', errorCode: 'error_saving_feedback', error: action.data.error })
    case 'DELETE_FEEDBACK_FETCHED':
        return Object.assign({}, newState, {})
    case 'DELETE_FEEDBACK_FAILED':
      return Object.assign({}, newState, { message: 'Errore nella cancellazione del feedback', errorCode: 'error_deleting_feedback', error: action.data.error })  
    case 'GET_FEEDBACK_FETCHED':
      return Object.assign({}, newState, { feedback: action.data.feedback })
    case 'GET_FEEDBACK_FAILED':
      return Object.assign({}, newState, { feedback: action.data.feedback, message: 'Errore nel recupero del feedback', errorCode: 'error_getting_feedback', error: action.data.error })
    case 'GET_FOLDERS_FETCHED':
      return Object.assign({}, newState, {projects: action.data.projects, customerProfile: action.data.customerProfile})
    case 'GET_FOLDERS_FAILED':
      return Object.assign({}, newState, { message: 'Errore durante il recupero delle cartelle', errorCode: 'error_getting_folders', error: action.data.error })
    case 'GET_USAGE_FETCHED':
      return Object.assign({}, newState, {usage: action.data})
    case 'GET_USAGE_FAILED':
      return Object.assign({}, newState, { message: 'Errore durante il recupero delle informazioni di utilizzo',errorCode: 'error_getting_feedback',  error: action.data.error })
    case 'ACCOUNT_DELETED':
      return Object.assign({}, {}, {data: []})
    case 'ACCOUNT_DELETING_ERROR':
      return Object.assign({}, newState, { message: 'Errore durante la cancellazione', errorCode: 'error_deleting', error: action.data.error })
    case 'CARD_CHANGE_SUCCESS':
      return Object.assign({}, newState, {data: action.data})
    case 'CARD_CHANGE_FAILED':
      return Object.assign({}, newState, { message: 'Errore durante il cambio del metodo di pagamento', errorCode: 'error_changing_payment_method', error: action.data.error })
    case 'CARD_ADD_SUCCESS':
      return Object.assign({}, newState, {data: action.data})
    case 'CARD_ADD_FAILED':
      return Object.assign({}, newState, { message: 'Errore durante la creazione del metodo di pagamento', errorCode: 'error_creating_payment_method', error: action.data.error })
    case 'SUBSCRIPTION_CHANGE_SUCCESS':
      return Object.assign({}, newState, {data: action.data})
    case 'SUBSCRIPTION_CHANGE_FAILED':
      return Object.assign({}, newState, { message: 'Errore durante il cambio del piano', errorCode: 'error_changing_plan_subscription', error: action.data.error })
    case 'GET_PRODUCTS_SUCCESS':
       return Object.assign({}, newState, {products: action.data})
    case 'GET_PRODUCTS_FAILED':
        return Object.assign({}, newState, { message: 'error_getting_products',  error: action.data.error })
    default:
      return Object.assign({}, newState, { loading_article: false, show_result: false, article: {} })
  }
}
